var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n\t\tnew-menu\r\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.04,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.04,
    y: 15,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.04,
    y: 30,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 10,
    height: 10,
    style: {
      fill: "#91979E"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalMenu);
export default __webpack_public_path__ + "static/media/global-menu.81cfdeb087b22895cd84b6b75df950a4.svg";
export { ForwardRef as ReactComponent };